import React from 'react'
import { Icon, Typography } from 'antd'
import VPlayer from 'components/VPlayer'
import { timeFormat } from 'util/utils'
import styles from './index.scss'
import cover from 'assets/images/middle_cover.png'

const { Paragraph } = Typography

type Collect = {
  collectCount: number
  hasCollect: 0 | 1
}
type Praise = {
  count: number
  hasPraise: 0 | 1
}
type TVType = 'm3u8' | 'audio' | 'video'

interface Props {
  id: number
  src: string
  img?: string
  title: string
  time: number
  courseTime?: number
  tags?: any
  people?: number
  link?: string
  collect?: Collect
  praise?: Praise
  type?: string
  onLike?: React.EventHandler<any>
  onPlay?: () => any
  onCollect?: React.EventHandler<any>
}

const types = [
  {
    key: '1000101',
    value: 'video',
  },
  {
    key: '1000103',
    value: 'audio',
  },
]

const VideoPanel = ({
  id,
  src,
  img,
  title,
  time,
  courseTime = 0,
  tags,
  people = 0,
  link,
  collect,
  praise,
  onLike,
  onPlay,
  type,
  onCollect,
}: Props) => {
  const isCollect = Boolean(collect.hasCollect)
  const isPraise = Boolean(praise.hasPraise)
  const isSelfVideo = str => /^https?\:\/{2}/.test(str)
  const sohufilter = _src => {
    const reg = /<embed(.*?)<\/embed>/
    if (reg.test(_src)) {
      return <div dangerouslySetInnerHTML={{ __html: _src.match(reg)[0] }} />
    }
    return <div dangerouslySetInnerHTML={{ __html: _src }} />
  }
  function download(url) {
    if (!url) {
      return
    }
    return window.open(url)
  }

  const collectBtn = (
    <div onClick={onCollect.bind(null)} className={styles.button}>
      <Icon
        type={isCollect ? 'star' : 'star-o'}
        style={{ color: isCollect && '#FF3C00', fontSize: 20 }}
      />
      <span>{isCollect ? '已收藏' : `${collect.collectCount}人收藏`}</span>
    </div>
  )

  const likeBtn = (
    <div onClick={onLike.bind(null)} className={styles.button}>
      <Icon
        type={isPraise ? 'like' : 'like-o'}
        style={{ color: isPraise && '#FF3C00', fontSize: 20 }}
      />
      <span>{`${praise.count || 0}人点赞`}</span>
    </div>
  )

  const videoRender = _type =>
    isSelfVideo(src) ? (
      <VPlayer
        type={types.filter(v => v.key === _type)[0].value as TVType}
        src={src}
        onplay={onPlay}
      />
    ) : (
      sohufilter(src)
    )

  return (
    <div className={styles.container}>
      <div className={styles.panel}>
        <div className={styles.title}>
          <span>{title}</span>
        </div>
        <div className={styles.tags}>{tags}</div>
        <div className={styles.info}>
          <div className={styles.description}>
            <span>{timeFormat(time, 'YY-MM-DD HH:mm')}</span>
          </div>
          <div className={styles.description}>
            {/* <span>{`${people > 9999 ? '9999+' : people}人学过`}</span> */}
            <span>{`${people}人学过`}</span>
          </div>
          <div className={styles.description}>
            <span>{`时长：${!!courseTime ? `${courseTime}分` : '未知'}`}</span>
          </div>
          <div
            className={styles.button}
            style={{
              opacity: !link && 0.5,
              cursor: !link && 'no-drop',
            }}
            onClick={download.bind(null, link)}
          >
            <Icon style={{ fontSize: 20 }} type="download" />
            <span>下载课件</span>
          </div>
          {collectBtn}
          {likeBtn}
          <div className={styles.copy}>
            <Paragraph copyable={{ text: location.href }}>分享视频</Paragraph>
          </div>
        </div>
        {type === types[1].key && <img src={img || cover} width="100%" />}
        {videoRender(type)}
      </div>
    </div>
  )
}

export default VideoPanel
